<template>
  <router-link :to="{ name: 'student-advisor-profile', params: { id: advisor.id } }" class="tu-person-card tu-browse-card">
    <div class="tu-person-card__media">
      <img v-if="advisor.image && !imageFailed" :src="advisor.image" alt="" loading="lazy" @error="imageFailed = true" />
      <span v-else class="tu-person-card__initials" aria-hidden="true">{{ initials }}</span>
    </div>
    <div class="tu-person-card__body">
      <div>
        <h3 class="tu-person-card__name">{{ advisor.first_name }} {{ advisor.last_name }}</h3>
        <p v-if="role" class="tu-person-card__role">{{ role }}</p>
      </div>
      <span v-if="background" class="tu-person-card__badge">{{ background }}</span>
      <p v-if="description" class="tu-person-card__desc">{{ description }}</p>
      <span class="tu-card-action"><span class="tu-card-action-label">View profile</span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 5 7 7-7 7"/></svg></span>
    </div>
  </router-link>
</template>

<script>
import { get } from 'lodash';
import { ADVISOR_BACKGROUND } from '@/common/constants';
import { stripHtmlTags } from '@/common/utils';

/** People card in the TransitionU card language: photo, name, role, background, excerpt, one action. */
export default {
  name: 'PersonCard',
  props: { advisor: { type: Object, required: true } },
  data() {
    return { imageFailed: false };
  },
  computed: {
    initials() {
      return [this.advisor.first_name, this.advisor.last_name]
        .filter(Boolean)
        .map(n => String(n).charAt(0).toUpperCase())
        .join('');
    },
    role() {
      return get(this.advisor, 'experience[0].title', '');
    },
    background() {
      const hit = ADVISOR_BACKGROUND.find(b => b.value === this.advisor.background);
      return hit ? hit.text : '';
    },
    description() {
      return String(stripHtmlTags(get(this.advisor, 'description', '')) || '').trim();
    },
  },
};
</script>
